import { CandidatePhoto } from '~/definitions/candidates';
import BaseAPIClient from '~/clientUtils/baseApiClient';
import { IMAGE_SIZE_VALUE_TYPE } from '~/consts/media';

class MediaApi extends BaseAPIClient {
    constructor() {
        super('', {});
    }

    async getMediaById(
        mediaId: string,
        options?: {
            size?: IMAGE_SIZE_VALUE_TYPE;
        }
    ): Promise<CandidatePhoto> {
        return this.request({
            method: 'GET',
            url: `/api/media/${mediaId}`,
            params: {
                size: options?.size,
            },
        });
    }
}

const mediaApi = new MediaApi();

export default mediaApi;
